import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { SquareButtonWithLoader } from '../../../../Styles';
import { TrashIcon } from '../../../../Styles';

import { removeDentiraMapping } from '../../../../../actions/inventoryActionsV2';

const DeleteMapping = ({ mapping, refresh = null, ...props }) => {
	const { disableSingleInventoryMapping } = props;
	const [deleting, setDeleting] = useState(false);

	const handleDelete = async () => {
		let { removeDentiraMapping } = props;

		setDeleting(true);

		await removeDentiraMapping(mapping);

		setDeleting(false);

		if(refresh){
			refresh();
		}
	};

	return (
		<>
			{!disableSingleInventoryMapping && (
				<SquareButtonWithLoader
					outline
					error
					loading={deleting}
					onClick={(e) => handleDelete()}
				>
					<TrashIcon />
				</SquareButtonWithLoader>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	const userSellerPortalConfig = state.session.sellerPortalConfig || {};

	const disableSingleInventoryMapping = supplierSellerPortalConfig.disable_single_inventory_mapping || userSellerPortalConfig.disable_single_inventory_mapping || false;

	return {
		disableSingleInventoryMapping,
	};
};

const mapDispatch = { removeDentiraMapping };

export default withRouter(connect(mapStateToProps, mapDispatch)(DeleteMapping));
